<template>
  <FullPageNotice home-to="/dashboard">
    <div
      class="mb-2 flex flex-row items-center gap-2 text-center text-[64px] font-semibold leading-[64px] text-red-primary"
    >
      <AlertIcon class="h-16 w-16" />
      <span>403</span>
    </div>
    <h1
      class="mb-4 text-center text-[36px] font-semibold leading-[44px] text-white-primary"
    >
      {{ t("errors.no_rights") }}
    </h1>
    <p
      class="mb-8 text-center text-[18px] font-normal leading-[150%] text-gray-primary"
    >
      {{ t("errors.no_access_description") }}
    </p>
    <HBFWButton class="guest-btn" @click="goBack">
      <p>{{ t("button.back") }}</p>
    </HBFWButton>
  </FullPageNotice>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useAuthStore } from "@/stores/auth/session";
import HBFWButton from "@/components/ui/buttons/MainButton.vue";
import FullPageNotice from "@/components/overlays/FullPageNotice.vue";
import AlertIcon from "@/icons/alert.svg";

const { t } = useI18n();

const authStore = useAuthStore();
function goBack() {
  authStore.logout();
}
</script>

<style scoped>
.guest-btn {
  width: 66.67% !important;
  background: #202220 !important;
  color: #ededed !important;
  border: 1px solid #404040 !important;
  border-radius: 0 !important;
}
.guest-btn:hover {
  background: #202220 !important;
  color: #ededed !important;
  box-shadow: none !important;
}
</style>
